import React from 'react';
import { useParams } from 'react-router-dom';
import senerfiBlanco from '../assets/images/senerfiblanco.png';
import BrandCopyright from '../Components/Common/BrandCopyright';
import SGIPanel from './modules/SGIPanel';
import { useWarehouse } from '../Components/useWarehouse/useWarehouse';

function reportSigPageDebug() {}

export default function SGI({ mobileMode = false } = {}) {
  const { location } = useParams();
  const { people, materials, assignments, warehouses } = useWarehouse();
  const isSigMobile = !!(process.env.REACT_APP_APP_VARIANT === 'sig_mobile');
  const isMobileMode = mobileMode || isSigMobile;

  React.useEffect(() => {
    // Permite diferenciar entre fallo de navegacion y fallo dentro del montaje del modulo SIG.
    reportSigPageDebug('R2', 'Pantalla SGI montada', {
      locationParam: location,
      mobileMode: !!mobileMode,
      isSigMobile,
      peopleCount: Array.isArray(people) ? people.length : -1,
      materialsCount: Array.isArray(materials) ? materials.length : -1,
      assignmentsCount: Array.isArray(assignments) ? assignments.length : -1,
      warehousesCount: Array.isArray(warehouses) ? warehouses.length : -1,
    });
  }, [assignments, isSigMobile, location, materials, mobileMode, people, warehouses]);

  const handleBrandClick = () => {
    window.location.reload();
  };

  return (
    <div
      className={`min-h-screen ${isMobileMode ? 'bg-slate-100' : 'bg-gray-50'}`}
      style={isMobileMode ? { backgroundImage: 'radial-gradient(circle at top, rgba(59,130,246,0.10), transparent 38%), linear-gradient(180deg, #F8FAFC 0%, #EEF2FF 100%)' } : undefined}
    >
      {!isMobileMode && (
        <div className="w-full shadow-md" style={{ backgroundColor: '#F07E2D' }}>
          <div className="max-w-6xl mx-auto flex items-center h-14 px-4">
            <img src={senerfiBlanco} alt="Senerfi" className="h-8 w-auto cursor-pointer" onClick={handleBrandClick} />
          </div>
        </div>
      )}

      <div className={isMobileMode ? 'p-3 sm:p-4' : 'p-6 flex items-center justify-center'}>
        <div className={isMobileMode ? 'rounded-[30px] w-full max-w-md' : 'bg-white rounded-2xl shadow-2xl border border-gray-200 p-8 max-w-xl w-full'}>
          <SGIPanel
            location={location}
            showLocation={!isMobileMode}
            people={people}
            materials={materials}
            assignments={assignments}
            warehouses={warehouses}
            sigMobileMode={isMobileMode}
          />
        </div>
      </div>

      {!isMobileMode && <BrandCopyright />}
    </div>
  );
}
